import { render, staticRenderFns } from "./VendorReports.vue?vue&type=template&id=4a2d4840&scoped=true&"
import script from "./VendorReports.vue?vue&type=script&lang=js&"
export * from "./VendorReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2d4840",
  null
  
)

export default component.exports